export default "__VITE_ASSET__DSuIB_z$__"